import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = "https://newalemny.3almny.app/api";

export const fetchSubjectTeachers = createAsyncThunk(
  "subjectTeachers/fetchSubjectTeachers",
  async ({ subjectId, page = 1 }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      if (!token) throw new Error("No authentication token found");
      
      const response = await fetch(`${BASE_URL}/subjects/subject_teachers/${subjectId}?page=${page}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        return rejectWithValue(data.message || "Failed to fetch subject teachers");
      }
      
      return data.result;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch subject teachers");
    }
  }
);

const subjectTeachersSlice = createSlice({
  name: "subjectTeachers",
  initialState: {
    teachers: [],
    loading: false,
    error: null,
    pagination: null,
    currentPage: 1,
  },
  reducers: {
    clearSubjectTeachers: (state) => {
      state.teachers = [];
      state.loading = false;
      state.error = null;
      state.pagination = null;
      state.currentPage = 1;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubjectTeachers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubjectTeachers.fulfilled, (state, action) => {
        state.loading = false;
        state.teachers = action.payload.data || [];
        state.pagination = action.payload.pagination || null;
      })
      .addCase(fetchSubjectTeachers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSubjectTeachers, setCurrentPage } = subjectTeachersSlice.actions;
export default subjectTeachersSlice.reducer; 